import API from "@/package/config/axios";
import { LocationQueryValue } from "vue-router";
import { IPlaceInfoResponse } from "@/modules/place-module";

export const apiGetPlace = (
  placeId: LocationQueryValue | LocationQueryValue[]
) => {
  return API.get<IPlaceInfoResponse>(`api/v2/places/${placeId}`);
};

export const apiSetFavoritePlace = (
  placeId: LocationQueryValue | LocationQueryValue[]
) => {
  return API.post(`api/v2/favorites/place/${placeId}/favorite`);
};

export const apiSetUnFavoritePlace = (
  placeId: LocationQueryValue | LocationQueryValue[]
) => {
  return API.post(`api/v2/favorites/place/${placeId}/unfavorite`);
};
